import React from "react";
import {Modal} from "flowbite-react";
import CustomImg from "../components/CustomImg";

function ModalImage(props) {
  const {openModal, setOpenModal, imageInfo} = props;
  return (
    <div className="relative">
      <Modal show={openModal} onClose={() => setOpenModal(false)} size="xl" dismissible={true} className="custom-modal">
        <div className="!p-0 !rounded-none bg-white shadow dark:bg-gray-700">
          <CustomImg src={imageInfo?.url} className="w-full h-auto"/>
        </div>
          <div className="fixed left-0 p-4 right-0 bottom-0 text-center font-bold text-lg  text-white">
            <span>{imageInfo?.file_name}</span>
          </div>
      </Modal>
    </div>

  );
}

export default ModalImage;
